import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Badge, Button } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function CallHistory({ user }) {
  const [calls, setCalls] = useState([]);

    const navigate = useNavigate();

    const callContact = (phone) => {
      navigate(`/make-call?number=${encodeURIComponent(phone)}`);
    };

    const handleDelete = async (id) => {
      if (!window.confirm("Delete this call log entry?")) return;

      try {
        const token = localStorage.getItem("token");
        await axios.delete(`/api/calls/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCalls(calls.filter((call) => call._id !== id));
      } catch (error) {
        console.error("Delete failed:", error);
      }
    };

  useEffect(() => {
    fetchCalls();
  }, []);

  const fetchCalls = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/calls', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCalls(response.data.calls || []);
    } catch (error) {
      console.error('Error fetching calls:', error);
    }
  };

  const getStatusBadge = (status, authenticated) => {
    if (status === 'blocked') return <Badge bg="danger">Blocked</Badge>;
    if (status === 'failed') return <Badge bg="warning">Failed</Badge>;
    if (status === 'completed' && authenticated) return <Badge bg="success">Completed</Badge>;
    if (status === 'completed') return <Badge bg="info">Completed</Badge>;
    return <Badge bg="secondary">{status}</Badge>;
  };

  const getDirectionIcon = (direction) => {
    return direction === 'inbound' ? (
      <i className="fas fa-arrow-down text-primary"></i>
    ) : (
      <i className="fas fa-arrow-up text-success"></i>
    );
  };

  return (
    <Container className="mainWrapper">
      <Row className="mb-4">
        <Col className="d-flex justify-content-between align-items-center">
          <h2 className="text-light fs-5 mb-0">
            <i className="fas fa-phone me-2 text-success"></i>
            Call History
          </h2>
          <Button
            variant="success"
            className="d-flex align-items-center gap-2 px-3"
            onClick={() => navigate('/make-call')}
          >
            <i className="fas fa-th"></i>
            <span>Open Dialpad</span>
          </Button>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <Card.Body>
              {calls.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-phone-slash fa-4x text-muted mb-3"></i>
                  <p className="text-muted">No call history yet</p>
                  <p className="text-muted small">
                    Your incoming and outgoing calls will appear here
                  </p>
                </div>
              ) : (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Direction</th>
                      <th>From</th>
                      <th>To</th>
                      <th>Status</th>
                      <th>Date & Time</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {calls.map((call) => (
                      <tr key={call._id}>
                        <td>{getDirectionIcon(call.direction)}</td>
                        <td>
                          <Badge
                            bg={
                              call.direction === "inbound"
                                ? "info"
                                : "secondary"
                            }
                          >
                            {call.fromNumber}
                          </Badge>
                        </td>
                        <td>
                          <Badge
                            bg={
                              call.direction === "outbound"
                                ? "info"
                                : "secondary"
                            }
                          >
                            {call.toNumber}
                          </Badge>
                        </td>
                        <td>
                          {getStatusBadge(call.status, call.authenticated)}
                        </td>
                        <td>{new Date(call.timestamp).toLocaleString()}</td>
                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-3">
                            <i
                              className="fas fa-phone text-success cursor-pointer"
                              title="Call"
                              style={{ fontSize: "16px" }}
                              onClick={() =>
                                callContact(
                                  call.direction === "inbound"
                                    ? call.fromNumber
                                    : call.toNumber
                                )
                              }
                            />

                            <i
                              className="fas fa-trash text-danger cursor-pointer"
                              title="Remove"
                              style={{ fontSize: "16px" }}
                              onClick={() => handleDelete(call._id)}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default CallHistory;
